<template>
	<inertia-head title="Affiliate Name Approval" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Affiliate Name Approval</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Welcome to TRC Admin Dashboard
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		
		<div class="block block-rounded">
			<div class="block-header">
				<div class="block-title"></div>
				<div class="block-options">
					
				</div>
			</div>
			<div class="block-content block-content-full">
				<div class="row mb-5">
					<div class="col-md-7">
						<form @submit.prevent="fetchAffiliateNames()">
							<input v-model="search" type="text" id="search" name="search" class="form-control" placeholder="Affiliate Name Info Search">
						</form>
					</div>
					<div class="col-md-3">
						<select v-model="status" class="form-select">
							<option value="All">All</option>
							<option value="Approved">Approved</option>
							<option value="Declined">Declined</option>
							<option value="Pending">For Approval</option>
						</select>
					</div>
					<div class="col-md-2">
						<button @click="fetchAffiliateNames()" type="button" class="btn btn-info">Search</button>
					</div>
				</div>
				<div class="table-responsive">
					<table class="table table-striped table-borderless table-hover table-vcenter">
						<thead>
							<tr>
								<th>Affiliate Name</th>
								<th>Member Name</th>
								<th>Username</th>
								<th>Mobile</th>
								<th>Created</th>
								<th>Approved</th>
								<th>Status</th>
								<th class="text-end">:::</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(aff, a_index) in affNameApproval.data" class="fs-sm">
								<td>{{aff.affname}}</td>
								<td>{{aff.member_name}}</td>
								<td>{{aff.username}}</td>
								<td>{{aff.mobile}}</td>
								<td>{{aff.affname_datetime}}</td>
								<td>{{aff.affname_approved_at}}</td>
								<td>
									<span class="badge" :class="{'bg-success':aff.affname_status=='Approved','bg-warning':aff.affname_status=='Pending','bg-danger':aff.affname_status=='Declined'}">{{ aff.affnam_status }}</span>
								</td>
								<td class="text-end">
									<button @click="viewAffliateNameContentModal(a_index)" type="button" class="btn btn-sm btn-alt-info"><i class="fa fa-pencil-alt"></i></button>
								</td>
							</tr>
							<tr v-if="affNameApproval.data.length <= 0">
								<td colspan="8" class="mb-0 fw-semibold text-center p-5">NO AFFILIATE NAME FOUND.</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination v-if="affNameApproval.data.length > 0" :collections="affNameApproval"/>
			</div>
		</div>
		<approval-affiliate-name-modal ref="ApprovalAffNameModal"/>

	</div>
</template>

<script>
import { onMounted, ref, watch, reactive } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'
import ApprovalAffiliateNameModal from '../../../Components/Admin/AffiliateProgram/ApprovalAffiliateNameModal'
import { createToaster } from '@meforma/vue-toaster';
import { Inertia } from '@inertiajs/inertia'

export default {
	layout: AuthLayout,
	props: {
		affNameApproval	: Object,
		status 			: String,
		search 			: String,
		api_response 	: Object
	},
	components:{ApprovalAffiliateNameModal},
	setup(props) {
		// onMounted(() => {
		// 	const pageContainer = document.getElementById('page-container')
		// 	if (pageContainer.classList.contains('sidebar-o-xs'))
		// 		pageContainer.classList.remove('sidebar-o-xs')
		// })
		
		const toast = createToaster();

		const status 				= ref(props.status??'Pending');
		const search 				= ref(props.search);

		const ApprovalAffNameModal = ref(null);

		const selectedAffliateNameContent = reactive({});

		const viewAffliateNameContentModal = (_index)=>{
			
			selectedAffliateNameContent.counter 			= props.affNameApproval.data[_index].counter;
			selectedAffliateNameContent.affname 			= props.affNameApproval.data[_index].affname;
			selectedAffliateNameContent.member_name 		= props.affNameApproval.data[_index].member_name;
			selectedAffliateNameContent.username 			= props.affNameApproval.data[_index].username;
			selectedAffliateNameContent.mobile 				= props.affNameApproval.data[_index].mobile;
			selectedAffliateNameContent.affname_status 		= props.affNameApproval.data[_index].affname_status;
			selectedAffliateNameContent.affname_datetime 	= props.affNameApproval.data[_index].affname_datetime;
			selectedAffliateNameContent.affname_ipadress 	= props.affNameApproval.data[_index].affname_ipadress;
			selectedAffliateNameContent.logs_affname 		= props.affNameApproval.data[_index].logs_affname;

			ApprovalAffNameModal.value.setAffNameContent(selectedAffliateNameContent);

			ApprovalAffNameModal.value.toggleModal();

		}

		const fetchAffiliateNames = () => {

							Inertia.get(
								route('admin.affiliate-program.affiliate-name-approval'),
								{
									status 		: status.value,
									search 		: search.value,
								},
								{
									preserveState: true,
									preserveScroll: true,
									only:['affNameApproval,api_response','search'],
								}
							)
						}

		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{

				if(value.result=="success")
				{
					toast.show("Successfully updated", { type: value.result});
				}else
				{
					toast.show("Failed to update", { type: "error"});
				}
			}
		})

		return{
			status,
			search,
			fetchAffiliateNames,
			viewAffliateNameContentModal,
			ApprovalAffNameModal
		}
	},
}
</script>
